import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFilterLineForAdsTimeFilter } from 'flow-doctor-lib/utils/filterRenderUtils';
import WalmartAbstractFilterRenderer from 'flow-doctor-lib/components/filters/WalmartAbstractFilterRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
const WalmartAdsTimeFilterRenderer = ({
  filter
}) => {
  return /*#__PURE__*/_jsx(WalmartAbstractFilterRenderer, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.filters.adsTime.label"
    }),
    filterLine: getFilterLineForAdsTimeFilter(filter)
  });
};
export default WalmartAdsTimeFilterRenderer;